import appStore from '@/AppStore'

/**
 * @returns a string - user currency symbol from vuex (login-store) default is IQD
 * */
export function getCurrencySymbol(): string {
  return appStore.getters['login/getCurrencySymbol'] || 'IQD'
}
